import * as Actions from "./actions/actions";
import * as ActionTypes from "./actions/types";
import requestHandler from "./api/api";
import reducer from "./reducer/reducer";

// Module Initialization.
export const PermissionsModule = {
	name: "permissions",
	actions: Actions,
	types: ActionTypes,
	reducer: reducer,
	api: requestHandler,
}